// Generated by genversion.
export const version = '0.27.6';
